
const IconValid = ({ width = 70 }) => (
    <img width={width} src={require(`./valid.png`).default} alt="imagen" />
)

const IconNoValid = ({ width = 70 }) => (
    <img width={width} src={require(`./no_valid.png`).default} alt="imagen" />
)

const IconNoFound = ({ width = 70 }) => (
    <img width={width} src={require(`./no_found.png`).default} alt="imagen" />
)

export {
    IconValid,
    IconNoFound,
    IconNoValid
}